export enum CustomerMarkerOverlayType {
  START,
  WELCOME,
  RELAX,
  BOOKMARK_KNOW,
  BOOST_YOUR_KNOWLEDGE,
  COMMUNITY_PART_1,
  COMMUNITY_PART_2,
  EVENTS,
  EDUCATION_COURSE,
  CONTACT_US,
  SUMMARY,
  CONGRATS,
}

export enum EmployeeMarkerOverlayType {
  START,
  WELCOME,
  RELAX,
  BOOKMARK_KNOW,
  COMMUNITY,
  RESOURCES,
  BOOKMARK_ONE_GENESYS,
  ELEARNING,
  SUMMARY,
}
